import React, { useState, useEffect } from 'react';

import {
  DataTableV2, DataTableBodyV2, DataTableHeadV2,
  DataTableHeadCellV2, DataTableRowV2, DataTableCellV2,
}
  from '@americanexpress/dls-react';
import { getRequiredData } from '../../constants';
import { parseHtml } from '../../utils/util';

const getVal = require('lodash/get');
/* eslint complexity: ["error", 40] -- need to increase complexity */
const StaticTable = (childProps) => {
  const [tableData, setTableData] = useState([]);
  const {
    fieldValue,
    tableDynamicProperties,
    filledFormData,
    cssProperties,
    memberInfo,
    fieldId,
    selectKey,
    preFilledWith,
    isPreFilled,
    fetchUrl,
    fieldLabel,
    setFormSubmissionPayload,
    limitRecords = null,
    objectOfFunctions,
    entityIndex,
  } = childProps;

  const tableLabelCss = fieldLabel.cssProperties.tableLabelCss ? fieldLabel.cssProperties.tableLabelCss : 'label-2';
  const noRecordLabelCss = fieldLabel.cssProperties.noRecordLabelCss ? fieldLabel.cssProperties.noRecordLabelCss : 'margin-1-t label-4';
  const limitedRecordsLabelCss = fieldLabel.cssProperties.limitedRecordsLabelCss ? fieldLabel.cssProperties.limitedRecordsLabelCss : 'body-1';

  useEffect(() => {
    let tempData = getRequiredData({
      isPreFilled,
      preFilledWith,
      fieldValue,
      selectKey,
      fetchUrl,
      filledFormData,
      memberInfo,
      entityIndex,
    });
    if (tempData === null || tempData === undefined) tempData = [];
    setTableData(tempData);
  }, [childProps]);

  const limitedTableRows = [];
  /**
   * not using array.splice or split as it's O(n)
   * Instead creating limited table rows by iteration
   */
  if (limitRecords && tableData.length > limitRecords) {
    const recordInfoString = `${fieldId}Records`;
    if (!filledFormData[recordInfoString]) {
      setFormSubmissionPayload({ ...filledFormData, ...{ elemId: null, limitedTableRecords: 'Yes', [recordInfoString]: tableData.length } });
    }
    for (let i = 0; i < limitRecords; i += 1) {
      const jsxEl = (
        <DataTableRowV2 key={i + 1}>
          {
            tableDynamicProperties.valueKeys.map((reqKey) => (
              <DataTableCellV2 key={reqKey}>{getVal(tableData[i], reqKey)}</DataTableCellV2>
            ))
          }
        </DataTableRowV2>
      );
      limitedTableRows.push(jsxEl);
    }
  }

  return (
    <div className={cssProperties.style}>
      {
        fieldLabel && fieldLabel.label
        && (
          <p className={tableLabelCss}>
            {fieldLabel.label}
          </p>
        )
      }

      {
        (tableData.length > 0
          || (tableDynamicProperties
            && tableDynamicProperties.generateRows
            && tableDynamicProperties.generateRows.length > 0))
        && (
          <DataTableV2
            bordered={true}
            id="table-base-instance"
            size="sm"
            striped={Object.prototype.hasOwnProperty.call(tableDynamicProperties, 'striped') ? tableDynamicProperties.striped : true}
            className="display-block-sm-down scroll-x-sm-down"
            style={tableDynamicProperties.isTableScrollable
              ? { display: 'block', 'max-height': `${tableDynamicProperties.maxHeight}`, 'overflow-y': 'scroll' }
              : null}
          >
            {
              tableDynamicProperties && tableDynamicProperties.displayHeaders && (
                <DataTableHeadV2>
                  <DataTableRowV2 style={tableDynamicProperties.isHeaderSticky ? { top: '0', position: 'sticky' } : null}>
                    {
                      tableDynamicProperties.displayHeaders.map((item, index) => (
                        <DataTableHeadCellV2
                          className={tableDynamicProperties.displayHeadersCss
                            ? tableDynamicProperties.displayHeadersCss[index]
                            : null}
                          key={item}
                          theme={tableDynamicProperties.displayHeadersTheme
                            ? tableDynamicProperties.displayHeadersTheme
                            : {}}
                        >
                          {item}
                        </DataTableHeadCellV2>
                      ))
                    }
                  </DataTableRowV2>
                </DataTableHeadV2>
              )
            }
            <DataTableBodyV2>
              {
                limitedTableRows.length > 0 && limitedTableRows
              }
              {
                // if we have table data and we have to create table rows from that data
                limitedTableRows.length === 0
                && tableData && tableData.length > 0 && tableData.map((item, rowIndex) => (
                  <DataTableRowV2 key={`${fieldId}-row-${rowIndex + 1}`}>
                    {
                      tableDynamicProperties.valueKeys.map((reqKey, cellIndex) => (
                        <DataTableCellV2 key={`${fieldId}-row-${rowIndex + 1}-cell-${cellIndex + 1}`}>{getVal(item, reqKey)}</DataTableCellV2>
                      ))
                    }
                  </DataTableRowV2>

                ))
              }
              {
                /**
                 * if we have to generate rows from payload/etc
                 * for static value cell use key 'staticValue' to generate that cell
                 * for dynamic value cell use key 'selectKey' to generate that cell
                 */
                /* eslint-disable react/no-array-index-key -- need */
                limitedTableRows.length === 0
                && (!tableData || (tableData && tableData.length === 0))
                && tableDynamicProperties.generateRows
                && tableDynamicProperties.generateRows.map((row, index) => (
                  <DataTableRowV2 key={index + 1}>
                    {
                      row.map((rowObj, pos) => (
                        <DataTableCellV2
                          key={`rowCell-${index}${pos}`}
                          className={rowObj.cellCss ? rowObj.cellCss : null}
                        >
                          {
                            rowObj.staticValue
                              ? parseHtml(rowObj.staticValue)
                              : getVal(objectOfFunctions, rowObj.selectKey)
                          }
                        </DataTableCellV2>
                      ))
                    }
                  </DataTableRowV2>
                ))
                /* eslint-enable react/no-array-index-key -- need */
              }
            </DataTableBodyV2>
          </DataTableV2>
        )
      }
      {
        tableData.length === 0
        && fieldLabel && fieldLabel.labelnorecords && (
          <p className={noRecordLabelCss}>{fieldLabel.labelnorecords}</p>
        )
      }
      {
        limitedTableRows.length > 0 && fieldLabel && fieldLabel.labelLimitedRecords
        && (
          <p className={limitedRecordsLabelCss}>{fieldLabel.labelLimitedRecords}</p>
        )
      }
    </div>
  );
};

export default StaticTable;
